import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'

const DeleteModal = ({ closeModal, handleDelete, translate }) => (
  <Modal closeModal={closeModal}>
    <h2>{translate('localUsers.modal.delete.title')}</h2>

    <p>{translate('localUsers.modal.delete.body')}</p>

    <Row className='align-right'>
      <button
        className='button-hollow button-hollow-primary margin-right'
        onClick={closeModal}
      >
        {translate('cancel_button')}
      </button>

      <button className='button button-danger' onClick={handleDelete}>
        {translate('remove_button')}
      </button>
    </Row>
  </Modal>
)

DeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default DeleteModal
